export const formatViewerUrl = (studypk: string, studyIuid: string) => {
  const queryParams = btoa(`pkid=${studypk}&pkuid=${studyIuid}`);
  return `/viewer?${queryParams}`;
};
